/**
 * <s-multibuy> — quantity deal cards. Picking a card sets the product form's
 * quantity input; the plain quantity row is hidden while the cards show.
 * The cards re-render with the product-form partial on variant change, and
 * s-variant-picker restores the quantity, so the matching card is re-checked.
 */
class SMultibuy extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    this.form = this.closest('form');
    const row = this.form?.querySelector('[data-quantity-row]');
    if (row) row.hidden = true;

    this.addEventListener('change', (event) => {
      const radio = event.target;
      if (!(radio instanceof HTMLInputElement) || radio.type !== 'radio') return;
      const input = this.#quantityInput();
      if (!input) return;
      input.value = radio.value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }, opts);

    this.form?.addEventListener('change', (event) => {
      if (event.target === this.#quantityInput()) this.#sync();
    }, opts);

    this.#sync();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #quantityInput() {
    const input = this.form?.querySelector('input[name="quantity"]');
    return input instanceof HTMLInputElement ? input : null;
  }

  #sync() {
    const quantity = String(this.#quantityInput()?.value || '1');
    const radios = [...this.querySelectorAll('input[type="radio"]')];
    const match = radios.find((radio) => radio.value === quantity);
    if (match) match.checked = true;
  }
}

if (!customElements.get('s-multibuy')) {
  customElements.define('s-multibuy', SMultibuy);
}
